import { render, staticRenderFns } from "./home-new-point.vue?vue&type=template&id=d0b54856&scoped=true&"
import script from "./home-new-point.vue?vue&type=script&lang=js&"
export * from "./home-new-point.vue?vue&type=script&lang=js&"
import style0 from "./home-new-point.vue?vue&type=style&index=0&id=d0b54856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b54856",
  null
  
)

export default component.exports